import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { API, setError } from '.'


export const submitOrder = createAsyncThunk('order/submitOrder', async (values, thunkAPI) => {
   try {
      const response = await API.post('/order', values)
      return response.data
   } catch (err) {
      thunkAPI.dispatch(setError({ action: 'submitOrder', code: err.response.status, message: err.message })) //------->???????????????????????
      return thunkAPI.rejectWithValue() ////////////////////////////////////-------------->???????????????????????
   }
})

const initialState = {
   modalIsOpen: false,
   paymentIsProceeded: false,
   paymentIssuccessful: false,
   loading: false,
   error: null
}

const orderSlice = createSlice({
   name: 'order',
   initialState,
   reducers: {
      openModalOrder(state) {
         state.modalIsOpen = true
      },
      closeModalOrder(state) {
         state.modalIsOpen = false
         state.paymentIssuccessful = false ////////////////////////////////////-------------->???????????????????????
         state.paymentIsProceeded = false ////////////////////////////////////-------------->???????????????????????
      }
   },
   extraReducers: builder => {
      builder.addCase(submitOrder.pending, (state, action) => {
         state.loading = true
         state.modalIsOpen = true
         state.paymentIsProceeded = true
         state.error = null
      })
      builder.addCase(submitOrder.fulfilled, (state, action) => {
         state.paymentIssuccessful = true
         state.paymentIsProceeded = true
         state.loading = false
      })
      builder.addCase(submitOrder.rejected, (state, action) => {
         state.paymentIssuccessful = false
         state.loading = false
         state.error = action.error ////////////////////////////////////-------------->???????????????????????
      })
   }
})

export const order = orderSlice.reducer
export const { openModalOrder, closeModalOrder } = orderSlice.actions
